import { useTranslation as useI18nextTranslation } from 'react-i18next';

/**
 * Custom hook for using translations with type safety
 * 
 * @example
 * const { t } = useTranslation();
 * const text = t('common.loading'); // Returns: "Loading..."
 * 
 * @example With interpolation
 * const text = t('wallet.balance', { amount: '10' });
 */
export const useTranslation = () => {
  return useI18nextTranslation();
};

